import { AbstractControl } from '@angular/forms';
import { isEmpty as _isEmpty } from 'lodash';
import { isNull, error } from 'util';

export function ValidateStudentIdPrimary(studenIdControlName) {
    return (control: AbstractControl) => {
        let errorsMin = null;
        // verify if there is errors to be validated
        if (control.errors) {
            // just execute if minlength or when the match is true
            if (control.errors.minlength) {
                if (control.value.length < control.errors.minlength.requiredLength) {
                    errorsMin = true;
                }
                else {
                    delete control.errors.studentIdPrimary;
                }
            }
            else if (control.errors.match) {
                if (control.parent.value.studentIdPrimary.length === control.parent.value.studentIdConfirm.length) {
                    delete control.errors.studentIdPrimary;
                }
            }
            if (errorsMin) {
                return { studentIdPrimary: true };
            }
        }
        else {
            // when the field has been validated the minglenght and then we press backspace key  errors are comming as null
            // so compare the new studentField value with the previous value saved in the parent form to make sure the validation for minlength is correct
            if (control.parent) {
                if (control.parent.value.studentIdPrimary && control.parent.value.studentIdConfirm) {
                    return control.parent.value.studentIdPrimary.length === control.value.length ? null : { studentIdPrimary: true };
                }
            }
        }
        return null;
    };
}
